module.exports = __webpack_public_path__ + "static/media/lock.1af32712.svg";